import { render } from "./UnsubscribeEasyTipView.vue?vue&type=template&id=6b82c083&scoped=true"
import script from "./UnsubscribeEasyTipView.vue?vue&type=script&lang=js"
export * from "./UnsubscribeEasyTipView.vue?vue&type=script&lang=js"

import "./UnsubscribeEasyTipView.vue?vue&type=style&index=0&id=6b82c083&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Adrian\\OneDrive\\Documents\\Appsanely Ltd\\thankU\\_thankuapp\\thanku\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b82c083"]])

export default __exports__